export default function getFieldSubtypeOptions(fieldType) {
  switch (fieldType) {
    case "date":
      return [
        { label: "Date only", value: "date" },
        { label: "Time only", value: "time" },
        { label: "Date & Time", value: "datetime" },
      ]
    default:
      return []
  }
}
